module.exports = __webpack_public_path__ + "media/assets/icons/mind-heart-847e25721942e1b3a4374446514b5041.svg";